import React from "react";
import { RouteComponentProps } from "react-router-dom";

export const EmailVerify = ({ history }: RouteComponentProps) => {
  return (
    <h2>Check your Email to Verify Your Email Address and Refresh the Page</h2>
  );
};
